import QuestionShow from './QuestionShow';

export default QuestionShow;
